import resiweb from "../../assets/homepage/resiweb.jpg";
import resiAccessoires from "../../assets/homepage/resiaccessoires.png";
import resiCal from "../../assets/homepage/Calendar.png";
import blog from "../../assets/homepage/Blog.png";
import {
  createStyles,
  Group,
  Title,
  Text,
  Card,
  SimpleGrid,
  Container,
  rem,
  Image,
  AspectRatio,
  Button,
} from "@mantine/core";

// Assuming you have a variable called 'languagePrefix' that determines the selected language
// You can use it to access the appropriate translations like this:

const useStyles = createStyles((theme) => ({
  title: {
    fontSize: rem(60),
    fontWeight: 540,
    textAlign: "center",
    lineHeight: 1.2,
    color: theme.black,

    [theme.fn.smallerThan("sm")]: {
      fontSize: rem(32),
    },

    margin: "auto",
  },

  description: {
    fontSize: rem(20),
    fontWeight: 400,
    textAlign: "center",
    lineHeight: 1.6,
    color: theme.colors.gray[6],
    letterSpacing: "1px",

    [theme.fn.smallerThan("sm")]: {
      fontSize: rem(16),
      maxWidth: "100%",
    },
    maxWidth: "65%",
    margin: "auto",
  },

  groupTitle: {
    fontSize: rem(18),
    fontWeight: 700,
    color: theme.colors.resirent[0],
    textAlign: "center",
  },

  titleCard: {
    [theme.fn.smallerThan("sm")]: {
      fontSize: rem(24),
      maxWidth: "100%",
      display: "block",
    },
    margin: "auto",
  },

  descriptionCard: {
    [theme.fn.smallerThan("sm")]: {
      fontSize: rem(16),
      maxWidth: "100%",
      textAlign: "center",
      display: "block",
    },
    margin: "auto",
    fontWeight: 400,
  },

  card: {
    transition: "transform 150ms ease, box-shadow 150ms ease",

    "&:hover": {
      transform: "scale(1.01)",
      boxShadow: theme.shadows.md,
    },

    backgroundColor: "#FFF5F9",
  },

  control: {
    "&:hover": {
      color: theme.white,
      backgroundColor: theme.colors.resirentPink[5],
    },

    border: `${rem(3)} solid ${
      theme.colorScheme === "dark"
        ? theme.colors.resirentPink[5]
        : theme.colors.resirentPink[8]
    }`,
    backgroundColor: theme.white,
    color: theme.colors.resirentPink[5],
    textAlign: "center", // Center-align the contents
  },
}));

const content = {
  "/": {
    groupTitle: "Our Portfolio",
    mainTitle: "Explore Our Featured Holiday Homes",
    description:
      "Discover a curated selection of stunning holiday homes created with ResiRent's website builder. Explore unique and beautiful accommodations handpicked from our hosts who have crafted their websites with love and care. Whether you're planning a relaxing getaway or an adventure-packed vacation, our featured holiday homes offer the perfect setting for your next trip.",
  },
  "/nl": {
    groupTitle: "Ons Portfolio",
    mainTitle: "Ontdek Onze Geselecteerde Vakantiehuizen",
    description:
      "Ontdek een zorgvuldig samengestelde selectie prachtige vakantiehuizen die zijn gemaakt met de website-builder van ResiRent. Verken unieke en mooie accommodaties, met zorg geselecteerd door onze gastheren die hun websites met liefde en zorg hebben gemaakt. Of u nu een ontspannende vakantie of een avontuurlijke vakantie plant, onze geselecteerde vakantiehuizen bieden de perfecte setting voor uw volgende reis.",
  },
  "/de": {
    groupTitle: "Unser Portfolio",
    mainTitle: "Entdecken Sie Unsere Ausgewählten Ferienhäuser",
    description:
      "Entdecken Sie eine sorgfältig ausgewählte Auswahl an atemberaubenden Ferienhäusern, die mit dem Website-Baukasten von ResiRent erstellt wurden. Erkunden Sie einzigartige und schöne Unterkünfte, die von unseren Gastgebern handverlesen wurden, die ihre Websites mit Liebe und Sorgfalt gestaltet haben. Ob Sie einen entspannenden Urlaub oder einen abenteuerreichen Urlaub planen, unsere vorgestellten Ferienhäuser bieten den perfekten Rahmen für Ihre nächste Reise.",
  },
};

export function HostHeader() {
  const { classes } = useStyles();
  const languagePrefix = window.location.pathname.startsWith("/nl")
    ? "/nl"
    : window.location.pathname.startsWith("/de")
    ? "/de"
    : "/";

  return (
    <Container
      fluid
      pt={100}
      pb={50}
      style={{ margin: "0 auto", backgroundColor: "#F9FAFB" }}
    >
      <Group position="center">
        <Text className={classes.groupTitle}>
          {content[languagePrefix].groupTitle}
        </Text>
      </Group>
      <Group position="center">
        <Title order={1} className={classes.title} my="sm">
          {content[languagePrefix].mainTitle}
        </Title>
      </Group>
      <Text className={classes.description} my="lg">
        {content[languagePrefix].description}
      </Text>
    </Container>
  );
}
